import { BaseService } from "@/api/services/baseService";
import { customerHttp } from "@/api";
import { Article, ArticleForm } from "@supplier/entity";
class CustomerArticleService extends BaseService<Article, Article, { type: number; app: number }, ArticleForm> {
    public async findArticle(params: { type: number; app: number }) {
        const { data } = await this.service.get(`${this.path}/type`, { params });
        return data;
    }
}
export const customerArticleService = new CustomerArticleService("/article", customerHttp.service);
